import React from 'react';
import * as ReactDOMClient from 'react-dom/client';

import MissionDetails from './EditMission/MissionDetails.js';
import MissionLaunch from './EditMission/MissionLaunch.js';
import MissionPrivacy from './EditMission/MissionPrivacy.js';
import MissionEditTimeframe from './EditMission/MissionEditTimeframe.js';

var body = window.jQuery("html, body");

/*
const MissionDetails = () => {
	return (
		<div>hay there</div>
	)
}
const MissionLaunch = () => {
	return (
		<div>hay there</div>
	)
}
const MissionPrivacy = () => {
	return (
		<div>hay there</div>
	)
}
const MissionEditTimeframe = () => {
	return (
		<div>hay there</div>
	)
}*/

class EditMission extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			missionType: 'solo',
			billingType: '',
			mission: {},
			invalid: [],
			errored: false,
			loading: true
		};

		this.handleChange = this.handleChange.bind(this);
		this.handleChangeMissionParam = this.handleChangeMissionParam.bind(this);
		this.handleChangeDate = this.handleChangeDate.bind(this);

		this.validateAndSave = this.validateAndSave.bind(this);

		this.scrollingStartMission = this.scrollingStartMission.bind(this);
		this.animateScrollingStart = this.animateScrollingStart.bind(this);

		this.currencies = [
			{id: 1, name: 'United States Dollar', alias: 'USD'},
			{id: 2, name: 'New Zealand Dollar', alias: 'NZD'},
			{id: 3, name: 'Australian Dollar', alias: 'AUD'},
			{id: 4, name: 'Canadian Dollar', alias: 'CAD'},
			{id: 5, name: 'Euro', alias: 'EUR'},
			{id: 6, name: 'British Pound2', alias: 'GBP'}
		];
	}

	componentDidMount() {
		this._getMission();
	}

	_getMission() {
		const missionId = window.missionId;

		fetch('/default/ajax?ajax=editmission_get_mission&mission_id='+missionId, {
			method: 'GET',
			headers: {
				Accept: 'application/json'
			}
		})
		.then(res => res.json())
	    .then(
	        (data) => {
	        	if (data.mission.name != '') {
					this.setState({missionType: data.mission_type, billingType: data.billing_type, mission: data.mission, loading: false});

					document.querySelector('#edit-mission-map-canvas-wrapper').style.display = "block";

					editMissionMapInit();
				}
				else {
					this.errorOut();
				}
	        },
	        // Note: it's important to handle errors here
	        // instead of a catch() block so that we don't swallow
	        // exceptions from actual bugs in components.
	        (error) => {
	        	this.errorOut();
	        }
	    )
	}

	errorOut() {
    	this.setState({errored:true});
	}

	handleChange(event) {
		const target = event.target;
	    const value = target.type === 'checkbox' ? target.checked : target.value;
	    const name = target.name;
 
	    this.setState({
	    	[name]: value
	    });
	}

	handleChangeMissionParam(event) {
		const target = event.target;
	    const value = target.type === 'checkbox' ? target.checked : target.value;
	    const name = target.name;	    

	    this.setState(prevState => {
			let mission = { ...prevState.mission };
			mission[name] = value;

			return { mission };
		});
	}

	validateAndSave() {
		if (this.validatePage()) {
			let formFields = {
				mission: this.state.mission
			}

			const updatedMapData = window.getUpdatedMapData();

			document.querySelector('input[name="map_data"]').value = updatedMapData;

			document.querySelector('input[name="state"]').value = JSON.stringify(formFields);

			this.scrollingStartMission();
		}
		else {
			// jQuery
			//body.stop().animate({scrollTop:0}, 250, 'swing');
		}
	}

	validatePage() {
		let valid = true;
		//return valid;//for testing

		let mission = this.state.mission;
		let missionKmTarget = parseFloat(document.querySelector('input[name="km_target"]').value);

		let invalidMessages = [];

		if (!(missionKmTarget > 0)) {
			valid = false;
			invalidMessages.push('Mission path is required.');
		}
		if (mission.travel_from.length < 1) {
			valid = false;
			invalidMessages.push('Mission Origin is required.');	
		}
		if (mission.travel_to.length < 1) {
			valid = false;
			invalidMessages.push('Mission Destination is required.');	
		}
		if (mission.name.length < 1) {
			valid = false;
			invalidMessages.push('Mission Name is required.');	
		}
		if (mission.description.length < 1) {
			valid = false;
			invalidMessages.push('Mission Description is required.');	
		}

		this.setState({invalid: invalidMessages});

		return valid;
	}

	handleChangeDate(name, newDate) {
		this.setState(prevState => {
			let mission = { ...prevState.mission };
			mission[name] = newDate;

			return { mission };
		});

		return true;
	}

	scrollingStartMission() {
		const $ = window.jQuery;

		$('#scrolling-start-spinner').show();
		// TODO: Uncommend once we have jquery.ticker again
		// Expand the height of the wrap element
		// $('#scrolling-start-wrap').animate({height:'330px'});
		// Scroll to the position
		// body.animate({scrollTop: $('#scrolling-start-wrap').offset().top}, 100);
		// Start the scrolling
		// window.scrollingStartPIndex = 1;
		// this.animateScrollingStart();
		// window.scrollingStartIntHandler = setInterval(() => {this.animateScrollingStart(); },3200);	//3200

		// setTimeout(function() {
			$('#new-mission-form').submit();
		// },3000);
	}

	animateScrollingStart() {
		const $ = window.jQuery;

		$('#scrolling-start > p#ind-'+window.scrollingStartPIndex).show().ticker({
			cursorList: "_",
			rate: 18
		}).trigger('play').trigger('stop');

		window.scrollingStartPIndex += 1;

		if (scrollingStartPIndex > 10) {
			clearInterval(window.scrollingStartIntHandler);
		}
	}

	render() {
		if (this.state.errored) {
			return (
				<div className="text-center mt-5">
					<h4 className="primary-color">Error loading edit mission. Please refresh the page.</h4>
				</div>
			)
		}
		else if (this.state.loading) {
			return (
				<div className="text-center mt-5">
					<div id="scrolling-start-spinner" className="spinner-border primary-color" role="status">
						<span className="visually-hidden">Loading...</span>
					</div>
					<h4 className="primary-color">Loading...</h4>
				</div>
			);
		}
		else {
			return (
				<div>
					<br />
					<h2>MISSION <span className="secondary-color">INFORMATION</span></h2>
					<br />

					<MissionDetails mission={this.state.mission} handleChange={this.handleChangeMissionParam} showWysiwyg={true} />

					<MissionEditTimeframe mission={this.state.mission} missionType={this.state.missionType} billingType={this.state.billingType} handleChange={this.handleChangeMissionParam} handleChangeDate={this.handleChangeDate} />

					<MissionPrivacy handleChange={this.handleChangeMissionParam} mission={this.state.mission} />

					{this.state.invalid.length > 0 && (
						<ul>
							{this.state.invalid.map(function(item, index) {
								return (
										<li className="danger" key={index}>
										{item}
										</li>
									)
								})
							}
						</ul>
					)}

					<div className="center">
						<button type="button" className="bg-img-btn blue-img next-step-btn" onClick={this.validateAndSave} data-nextstep="3">SAVE MISSION</button>
					</div>
				</div>
			);
		}
	}
}

const rctEditMission = document.getElementById('rct-editmission');

if (rctEditMission !== null) {
	ReactDOMClient.createRoot(rctEditMission).render(<EditMission />);
}